import { ref } from 'vue'

export const Prefetched = 0x1
export const PrefetchOk = 0x2

export function setupPrefetchData (storeSetup) {
  const { fetchData } = storeSetup
  const prefetched = ref(0)

  return Object.assign(storeSetup, {
    prefetched,
    isPrefetchOk () {
      return !!(prefetched.value & PrefetchOk)
    },
    async prefetchData (options) {
      if (prefetched.value) {
        return
      }

      prefetched.value = prefetched.value | Prefetched
      const result = await fetchData(options)
      if (!result) {
        return
      }

      prefetched.value = prefetched.value | PrefetchOk
    }
  })
}
